<template>
  <div
    class="bs-wrapper register-box"
    :style="{ height: stageHeight + 'px' }"
    v-show="!isLoad"
  >
    <div class="activity-wrapper">
      <div class="section3 flex-col">
        <div class="main1 flex-col">
          <div class="main2 flex-col">
            <div class="section4 flex-col">
              <van-image
                class="head-img"
                :src="headDiagram"
                @click="goDetail"
              />
            </div>
          </div>
        </div>
        <div class="layer5 flex-row">
          <span class="word3">申请内容</span>
          <span class="word4">是否参加</span>
        </div>
        <!-- 单选 -->
        <div v-for="(item, index) in list" :key="item.id" class="bs-list-row">
          <van-cell title-class="cell-left" value-class="cell-right">
            <template #title>
              <div class="van-ellipsis">活动名称：{{ item.project }}</div>
            </template>
            <template #default v-if="item.mustAttend == 0">
              <van-radio-group
                v-model="item.feedbackState"
                direction="horizontal"
                @change="
                  e => {
                    change(e, index);
                  }
                "
              >
                <van-radio :name="1">
                  是
                  <template #icon="props">
                    <i
                      class="img-icon"
                      :class="props.checked ? '' : 'active'"
                    />
                  </template>
                </van-radio>
                <van-radio :name="0">
                  否
                  <template #icon="props">
                    <i
                      class="img-icon"
                      :class="props.checked ? '' : 'active'"
                    />
                  </template>
                </van-radio>
              </van-radio-group>
            </template>
            <template #default v-else>
              全部商户
            </template>
          </van-cell>
        </div>
        <!-- 备注 -->
        <span class="remarks-title">活动备注</span>
        <div class="remarks-input">
          <van-field
            v-model="remark"
            :border="true"
            rows="5"
            autosize
            label=""
            type="textarea"
            maxlength="300"
            placeholder="请填写活动备注"
            show-word-limit
          />
        </div>
      </div>
    </div>
    <div class="operate-btns">
      <div class="section5" @click="goDetail">
        <span class="word9">查看详情</span>
      </div>
      <div class="section5 section6" @click="goRegister">
        <span class="word9">立即提交</span>
      </div>
    </div>
    <!--异常情况-->
    <div class="unusual-box flex-col" v-if="unusual.isShow">
      <img
        :src="require('../../assets/img/common/noSearch.png')"
        alt=""
        class="img"
      />
      <span>{{ unusual.message }}</span>
    </div>
  </div>
</template>

<script>
import { Image, Field, Cell, RadioGroup, Radio, Toast } from 'vant';
import { mapState } from 'vuex';

import {
  getRegDetail,
  getDetail,
  getMsgDetail,
  editDetail,
  ACTIVITY_STATUS,
} from '@/api/activity';

export default {
  name: 'plazaActivityReg',

  mixins: [],

  components: {
    [Image.name]: Image,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
  },

  props: {},

  data() {
    return {
      // 活动头图
      radio: 1,

      id: 1,
      // 活动名称
      name: '',
      // 活动详情
      detail: '',
      // 开始时间
      startTime: '',
      // 结束时间
      endTime: '',
      // 活动头图
      headDiagram: '',
      // 活动链接
      link: '',
      // 活动地址
      address: '',
      // way：1 自定义内容 2是链接
      way: 1,

      remark: '',
      list: [],
      activityId: '',
      storeId: '',
      storeName: '',

      // 是否在提交
      isSubmit: false,
      unusual: {
        isShow: false,
        message: '',
      },
      isLoad: true,
    };
  },

  computed: {
    ...mapState({
      stageHeight: state => state.base.stageHeight,
    }),
  },

  watch: {
    '$route.query.eventId': {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          if (!newVal) return;
          this.init();
        }
      },
    },
  },

  created() {},
  mounted() {
    this.init();
  },

  destroyed() {},

  methods: {
    async init() {
      this.activityId = this.$route.query.eventId;
      this.storeName = this.$store.state.base.storeName;
      let query = this.$route.query;
      try {
        let res = null;
        this.isLoad = true;
        if (query.id) {
          // 从，消息-广场活动，进入
          res = await getMsgDetail(
            JSON.stringify({
              eventId: query.eventId,
              id: query.id,
              noticeType: query.noticeType,
              storeId: this.$store.state.account.storeId,
              type: query.type,
            })
          );
        } else {
          // 从，首页-广场活动或首页-待办事宜-广场活动，进入
          res = await getDetail({
            storeId: this.$store.state.account.storeId,
            storeName: this.$store.state.base.storeName,
            id: query.eventId,
          });
        }

        (this.id = res.id || query.eventId),
          // 活动名称
          (this.name = res.name),
          // 活动详情
          (this.detail = res.detail);
        // 开始时间
        this.startTime = String(res.startTime).split(' ')[0];
        // 结束时间
        this.endTime = String(res.endTime).split(' ')[0];
        // 活动头图
        this.headDiagram = res.headDiagram;
        // 活动链接
        this.link = res.link;
        // 活动地址
        this.address = res.address || '';
        // 下方方式
        this.way = res.way;
        // 反馈
        this.remark = res.remark;

        this.isLoad = false;

        // console.log(res)
      } catch (error) {
        this.isLoad = false;
        if (Object.values(ACTIVITY_STATUS).includes(error.errCode)) {
          this.unusual = {
            isShow: true,
            message: error.message,
          };
        } else {
          Toast({
            message: error.message || '获取活动详情失败',
            duration: 1000,
            position: 'top',
          });
        }
      }

      try {
        let res = await getRegDetail({
          storeId: this.$store.state.account.storeId,
          id: this.$route.query.eventId,
        });

        // 反馈
        this.remark = res.remark;
        this.activityId = res.activityId;
        this.storeId = res.storeId;
        this.storeName = res.storeName;
        this.list = [];
        res.squareActivityDetailVos.forEach(el => {
          el.feedbackState = el.feedbackState || 0;
          this.list.push(el);
        });
      } catch (error) {
        Toast({
          message: error.message || '获取报名详情失败',
          duration: 1000,
          position: 'top',
        });
      }
    },
    async goRegister() {
      if (this.isSubmit) return;
      if (this.$bsUtils.bsHasEmojiCharacter(this.remark)) {
        Toast({
          message: '备注不能包含表情符号',
          duration: 3000,
          position: 'top',
        });
        return;
      }
      this.isSubmit = true;
      try {
        await editDetail(
          JSON.stringify({
            activityId: this.activityId,
            remark: this.remark,
            squareActivityDetailVos: this.list,
            storeId: this.storeId,
            storeName: this.storeName,
          })
        );
        Toast({
          message: '提交成功',
          duration: 3000,
          position: 'top',
        });
        this.$router.replace({ name: 'plazaActivity' });
      } catch (error) {
        Toast({
          message: error.message || '提交失败',
          duration: 1000,
          position: 'top',
        });
      }
      setTimeout(() => {
        this.isSubmit = false;
      }, 1000);
    },
    goDetail() {
      if (this.way == 1) {
        this.$router.push({
          name: 'plazaActivityDetail',
          query: { eventId: this.id },
        });
      } else {
        window.location.href = this.link;
      }
    },
    change(name, index) {
      this.list[index].feedbackState = name;
    },
  },
};
</script>

<style lang="less" scoped>
.bs-list-row {
  position: relative;
}
.bs-list-row::after {
  position: absolute;
  box-sizing: border-box;
  content: ' ';
  width: 320px;
  height: 1px;
  left: 16px;
  bottom: 0;
  background-color: rgba(228, 228, 228, 1);
}
.bs-wrapper {
  padding-top: 10px;
  max-height: calc(100% - 74px);
  overflow: auto;
}
.activity-wrapper {
  margin-left: 10px;
  width: 355px;
  margin-bottom: 74px;
}
.img-icon {
  display: block;
  width: 16px;
  height: 16px;

  background: url(../../assets/icons/radioIcon-1.png);
  background-size: contain !important;
}
.img-icon.active {
  background: url(../../assets/icons/radioIcon-2.png);
}
.cell-left {
  & > div {
    width: 234px;
    color: #666666;
    font-size: 13px;
  }
  text-align: left;
}
.cell-right {
  width: 86px;
  display: flex;
  justify-content: flex-end;
  /deep/.van-radio--horizontal {
    margin-left: 6px;
    margin-right: 0px;
  }
  /deep/.van-radio-group {
    flex-flow: row;
  }
  /deep/.van-radio__label {
    margin-left: 4px;
    font-size: 13px;
  }
  /deep/.van-radio__icon {
    height: auto;
    line-height: auto;
  }
}

.remarks-title {
  width: 320px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(102, 102, 102, 1);
  font-size: 13px;
  white-space: nowrap;
  line-height: 16px;
  text-align: left;
  align-self: flex-start;
  margin: 15px 0 0 18px;
}
.section3 {
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.06);
  align-self: center;
  width: 355px;
  justify-content: flex-start;
  padding-top: 16px;
  padding-bottom: 20px;
  align-items: center;
  .main1 {
    width: 327px;
    // height: 439px;
    .main2 {
      position: relative;
      width: 327px;
      height: 163px;
      border-radius: 8px;
      overflow: hidden;
      .section4 {
        height: 163px;
        width: 327px;
        justify-content: flex-end;
        align-items: flex-start;
        position: absolute;
        left: 0;
        top: 0;
      }
      .head-img {
        display: block;
        width: 327px;
        height: 163px;
        background: #d8d8d8;
        border-radius: 8px;
        overflow: hidden;
      }
    }
  }
}
.operate-btns {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.section5,
.section6 {
  // position: fixed;
  // bottom: 10px;

  height: 44px;
  line-height: 44px;
  border-radius: 22px;
  border: 1px solid #FF6F00;
  box-shadow: 0px 3px 12px 1px rgba(228, 19, 53, 0.35);
  background: #f8f8f8;
  text-align: center;
  margin: 0 10px;
  width: 170px;
  .word9 {
    z-index: 48;
    // width: 64px;
    display: block;
    overflow-wrap: break-word;
    color: #FF6F00;
    font-size: 16px;
    font-family: PingFangSC-Medium;
    white-space: nowrap;
    line-height: 44px;
    text-align: center;
  }
}

.section6 {
  border: none;
  background: #FF6F00;
  .word9 {
    color: rgba(255, 255, 255, 1);
  }
}

.layer5 {
  width: 329px;
  height: 24px;
  justify-content: space-between;
  margin: 17px 0 0 2px;
}

.word3 {
  width: 64px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 16px;
  font-family: PingFangSC-Medium;
  white-space: nowrap;
  line-height: 16px;
  text-align: left;
}

.word4 {
  width: 48px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 12px;
  font-family: PingFangSC-Medium;
  white-space: nowrap;
  line-height: 16px;
  text-align: left;
  margin-top: 1px;
}
.remarks-input {
  margin-top: 16px;
  width: 310px;
  /deep/.van-cell.van-field {
    border: solid 1px #cccccc;
    border-radius: 4px;
    padding: 6px;
    font-size: 13px;
    textarea {
      color: #666666;
    }
  }
}

.register-box {
  position: relative;
  .unusual-box {
    position: absolute;
    background: #fff;
    top: 0;
    left: 0;
    align-items: center;
    width: 100%;
    height: 100%;
    .img {
      margin-top: 62px;
      margin-bottom: 25px;
      width: 250px;
    }
    span {
      font-size: 13px;
      font-weight: 400;
      color: #999999;
    }
  }
}
</style>
